// extracted by mini-css-extract-plugin
export default {"item":"item--evCRa","checkIcon":"checkIcon--maHfA"};